export default __webpack_public_path__ + "static/media/profiel.80522e5a.svg";